import req from '@sportninja/common/api/request'
import { setSessionToken } from '@sportninja/common/api/account'

export const delay = (time) => {
  time = time || 2000
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

class Service {
  async login(email, password) {
    const response = await req('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    })

    await setSessionToken(response?.access_token)

    return response
  }

  async getInviteInfo(inviteId) {
    const response = await req(
      `/public/schedules/${inviteId}/registration/onboarding`
    )

    const sports = await req('/sports')
    // return response.data

    return {
      invite: response.data,
      sports: sports?.data,
    }
  }

  async getUserInformation(shouldFetchUserInfo = true, scheduleId) {
    const user = shouldFetchUserInfo ? await req('/users/me') : null
    const teams = await req(
      `/users/me/team-officials/registration/schedule/${scheduleId}`
    )

    return {
      user: user?.data,
      teams: teams?.data,
    }
  }

  async getPlayerInformation(shouldFetchUserInfo = true, scheduleId) {
    const user = shouldFetchUserInfo ? await req('/users/me') : null
    const teams = await req(
      `/schedules/${scheduleId}/registration/onboarding/player/teams`
    )
    // const player = await req(`/users/me/team-officials/registration/schedule/${scheduleId}`)
    const skillLevel = await req('/sports/skill-level-tiers')

    return {
      user: user?.data,
      teams: teams?.data,
      player: {},
      skillLevel: skillLevel?.data,
    }
  }

  async registerTeam({ teamId, registrationId, scheduleId }) {
    const response = await req(
      `/schedules/${scheduleId}/registration/onboarding`,
      {
        method: 'POST',
        body: JSON.stringify({
          team_id: teamId,
          schedule_registration_id: registrationId,
        }),
      }
    )

    return response.data
  }

  async registerPlayer({ teamId, rosterId, scheduleId, playerInfo }) {
    const response = await req(
      `/schedules/${scheduleId}/registration/onboarding/player/team/${teamId}/roster/${rosterId}`,
      {
        method: 'POST',
        body: JSON.stringify({
          name_first: playerInfo.firstName,
          name_last: playerInfo.lastName,
          email: playerInfo.email,
          birth_date: playerInfo.dateOfBirthday,
          player_skill_level_tier_id: playerInfo.skillLevel,
          player_number: playerInfo.number,
          player_type_id: playerInfo.position,
        }),
      }
    )

    return response
  }
}

export const RegistrationInviteService = new Service()
